import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

export interface SearchResultsSectionConfiguratorContextType {
  isNewCLPFiltersExperimentActive: boolean
  showDesktopFilterWithSidebar: boolean
  showMobileFilterWithDrawer: boolean
  isNewCLPFiltersExperimentInitialized: boolean
  showDesktopFilterWithDrawer: boolean
}

const CONTEXT_ERROR_MESSAGE =
  'useSearchResultsSectionConfigurator must be used within a SearchResultsSectionConfiguratorProvider'

const SearchResultsSectionConfiguratorContext = createContext<SearchResultsSectionConfiguratorContextType | null>(null)

export function useSearchResultsSectionConfigurator() {
  const context = useContext(SearchResultsSectionConfiguratorContext)
  if (!context) {
    throw new Error(CONTEXT_ERROR_MESSAGE)
  }
  return context
}

export function SearchResultsSectionConfiguratorProvider({
  children,
  config,
}: PropsWithChildren<{ config: SearchResultsSectionConfiguratorContextType }>) {
  const contextValue = useMemo(() => config, [config])

  return (
    <SearchResultsSectionConfiguratorContext.Provider value={contextValue}>
      {children}
    </SearchResultsSectionConfiguratorContext.Provider>
  )
}
